

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Loading = ({ message = 'Cargando...', }) => {
       

    return (
        <>
            <div >
            <div className="d-flex flex-column justify-content-center align-items-center vh-100">
              <div className="spinner-border text-primary mb-3" role="status">
                <span className="visually-hidden">{message}</span>
              </div>
              <h5 className="text-muted">{message}</h5>
            </div>
        </div>
        </>
    );
};

export default Loading;